import React from "react"
import SEO from "../components/SEO.jsx"
import Hero from "../components/Hero.jsx"
import ChallengesSection from "../components/home/ChallengesSection.jsx"
import ServicesGrid from "../components/home/ServicesGrid.jsx"
import SelectedProjects from "../components/home/SelectedProjects.jsx"
import CapabilitiesSection from "../components/home/CapabilitiesSection.jsx"
import AboutStudio from "../components/home/AboutStudio.jsx"
import FinalCTA from "../components/home/FinalCTA.jsx"
import useHashScroll from "../hooks/useHashScroll.js"

// Website packages and add-ons (PackagesList, AddOns and their portals) are
// no longer shown on the homepage. The components and data are unchanged;
// their public placement is pending approval (REPOSITIONING-PLAN.md, D1).

export default function Home() {
  // Scroll to section anchors such as /#services from the navigation.
  useHashScroll()

  return (
    <div className="bg-white text-brand-text">
      <SEO
        title="Web Design Adelaide, SEO & Google Ads | 2merative"
        description="Adelaide digital studio for established businesses. Premium websites, SEO & GEO, Google Ads, AI chatbots and ongoing support for a stronger online presence."
        path="/"
        image="/og-image.png"
      />

      <Hero />
      <ChallengesSection />
      <ServicesGrid />
      <SelectedProjects />
      <CapabilitiesSection />
      <AboutStudio />
      <FinalCTA />
    </div>
  )
}
